import { render, staticRenderFns } from "./CondicionesGenerales.vue?vue&type=template&id=3088f72c"
import script from "./CondicionesGenerales.vue?vue&type=script&lang=js"
export * from "./CondicionesGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports